export type IncidentType = 'INCIDENT' | 'PROBLEM' | 'CHANGE';
export type DisplayIncidentType = 'open' | 'close' | 'both' | 'user-defined';

export enum IncidentTypes {
	INCIDENT = 'INCIDENT',
	PROBLEM = 'PROBLEM',
	CHANGE = 'CHANGE',
}

export interface IMessages {
	[key : string] : string;
}

export interface ICustomerListData {
	display : boolean;
	id : number;
	scn : number;
	customerName : string;
	type : IncidentType;
	title : string;
	location : string;
	creationDate : string;
	creationDateTamestamp : number;
	date : string,
	status : 'open' | 'closed';
	searchValue? : string;
	[key : string] : any;
}

export interface IIncidentAttributes {
	label : string;
	value : string;
}

export interface IIncidentData {
	creationDate : string;
	id : number;
	title : string;
	type : IncidentType;
	internalDescription? : string;
	location : string;
	description : string;
	partnerWorkaround? : string;
	attributes : IIncidentAttributes[];
	[key : string] : any;
}

export interface IHeadingInfo {
	title : string;
	sortName : string;
	sort : boolean;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/model.ts